module.exports = __webpack_public_path__ + "assets/American.d145dcf3.svg";